import { Component, OnInit } from '@angular/core';
import { FormBuilder} from '@angular/forms';

import { KeywordService, NotificationService } from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({ templateUrl: './keyword-advance.component.html' })
export class KeywordAdvanceComponent implements OnInit {

  keywordUploading = false;
  affiliateUploading = false;

  uploadResultUrl = '';

  constructor(private fb: FormBuilder,
    private keywordSvc: KeywordService,
    private notification: NotificationService,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {
  }

  openModal(targetModal) {
    this.modalService.open(targetModal, {
      windowClass: 'modal-holder',
      size: 'lg'
    });
  }

  keywordFile: File = null;
  affiliateFile: File = null;

  onKeywordFileChange(event){
     if(event != null && event.target != null && event.target.files != null && event.target.files.length > 0){
       this.keywordFile = event.target.files[0];
     }else{
       this.keywordFile = null;
     }
  }

  onAffiliateFileChange(event){
    if(event != null && event.target != null && event.target.files != null && event.target.files.length > 0){
      this.affiliateFile = event.target.files[0];
    }else{
      this.affiliateFile = null;
    }
  }

  uploadKeywords() {
    if(this.keywordFile == null){
      this.notification.showWarning("Pls select file first", "Upload Result");
      return;
    }
    this.uploadResultUrl = '';
    this.keywordUploading = true;
    var data = new FormData();
    data.append("file", this.keywordFile, this.keywordFile.name);
    this.keywordSvc.uploadKeywords(data)
      .subscribe(res => {
        this.keywordUploading = false;
        console.log(res);
        if(res != null && res.status == 1){
          this.uploadResultUrl = res.data;
          document.getElementById('uploadResultBtn').click();
        }else{
          this.notification.showError(res.msg, "Upload Keyword Result");
        };
      });
  }

  uploadAffiliates() {
    if(this.affiliateFile == null){
      this.notification.showWarning("Pls select file first", "Upload Result");
      return;
    }
    this.uploadResultUrl = '';
    this.affiliateUploading = true;
    var data = new FormData();
    data.append("file", this.affiliateFile, this.affiliateFile.name);
    this.keywordSvc.uploadAffiliate(data)
      .subscribe(res => {
        this.affiliateUploading = false;
        console.log(res);
        if(res != null && res.status == 1){
          this.uploadResultUrl = res.data;
          document.getElementById('uploadResultBtn').click();
        }else{
          this.notification.showError(res.msg, "Upload Affiliate Result");
        }
      });
  }
}
